<template>
  <div>
    <el-carousel  :interval="5000" arrow="always" :loop="true">
      <el-carousel-item v-for="(item,index) in bannerList" :key="index">
        <el-image  style="height:349px;width:  1150px;border-radius: 20px;" :src="item.icon" @click="bannerClick(item)">
          <div slot="error" class="image-slot" style="background-color: rgb(238, 238, 238);height: 100%;width: 100%">
          </div>
          <div slot="placeholder" class="image-slot" style="background-color: rgb(238, 238, 238);height: 100%;width: 100%">
          </div>
        </el-image>
      </el-carousel-item>
    </el-carousel>
  </div>
</template>

<script>

export default {
  name: "banner",
  data() {
    return {
      bannerList: [{
        icon: ''
      }]
    }
  },
  methods: {
    init(bannerList){
      this.bannerList = bannerList;
    },
    /**
     * 轮播图点击
     */
    bannerClick(item) {
      switch(item.jumpType){
        case "1":
          // 跳转外部链接
          window.open(item.jumpLink);
          break;
        case "2":
          // 跳转登录
          this.$router.push('/login');
          break;
        default:
          break;
      }
    }
  }
}
</script>

<style >
  .el-carousel.el-carousel--horizontal {
    border-radius: 20px;
    height:349px;
  }

  .el-carousel__item {
    height:349px !important;
  }
</style>



// WEBPACK FOOTER //
// src/pages/webMall/index/banner.vue